import { Action, ActionReducer, combineReducers } from '@ngrx/store';

import * as fromGateways from './gateways.reducer';

export const featureKey = 'oyanGateways';

export interface GatewaysState {
  [fromGateways.featureKey]: fromGateways.State;
}

export interface State {
  [featureKey]: GatewaysState;
}

export function reducers(state: GatewaysState, action: Action): ActionReducer<GatewaysState> {
  return combineReducers({
    [fromGateways.featureKey]: fromGateways.reducer
  })(state, action) as unknown as ActionReducer<GatewaysState>;
}
